import axios from 'axios'
import {connections} from '../../configs/connection';

const instance = axios.create({
    baseURL: connections.catalog,
    // headers: {'Authorization': JSON.parse(localStorage.getItem('identity'))?.accessToken}
})

export default instance
